// Mood Board Color
export const BG_PRIMARY = 'rgba(247,233,222,1)';
export const BG_SECONDARY = 'rgba(220,200,177,1)';
export const BG_ALTERNATIVE = '#FFFFFF';
export const BG_OPACITY = '#323030';

export const ASSETS_PRIMARY = 'rgba(119,87,59,1)';
// Text Color
export const TEXT_PRIMARY = 'rgba(119,87,59,1)';
export const TEXT_SECONDARY = 'rgba(39,30,12,1)';
export const TEXT_ALTERNATIVE = 'rgba(255,255,255,1)';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgba(39,30,12,1)'; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya
